var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKmaway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0815 10.4454L12.4715 7.39516C12.2616 6.34563 11.3301 5.57812 10.2543 5.57812H9.65084H8.6669H3.74719C3.45201 5.57812 3.16339 5.63716 2.90756 5.74214L2.90625 5.7428L12.8532 11.958C13.1012 11.4989 13.1865 10.9623 13.0815 10.4454Z",
    fill: "#484848",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72587 4.36461C8.49084 4.14579 9.04924 3.45803 9.04924 2.64346C9.04924 1.65274 8.22322 0.849609 7.20431 0.849609C6.18533 0.849609 5.35938 1.65274 5.35938 2.64346C5.35938 3.45256 5.91028 4.13655 6.6673 4.36013C6.65724 4.40033 6.65191 4.44233 6.65191 4.48554V7.3391C6.65191 7.63126 6.89553 7.86813 7.19601 7.86813C7.49656 7.86813 7.74017 7.63126 7.74017 7.3391V4.48554C7.74017 4.44393 7.73525 4.40345 7.72587 4.36461Z",
    fill: "#484848",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04048 6.36328V6.36525C1.78465 6.65387 1.60754 7.00153 1.52883 7.39511L0.918782 10.4453C0.807269 10.9963 0.912223 11.567 1.19429 12.0459L1.19494 12.0472L6.45836 9.12357L2.04048 6.36328Z",
    fill: "#484848",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.90234 12.7795C1.90366 12.7801 1.90431 12.7814 1.90562 12.7821C2.2664 13.0248 2.69278 13.1494 3.13227 13.1494H10.8595C11.3383 13.1494 11.8041 12.9985 12.1845 12.7099C12.1858 12.7093 12.1878 12.7073 12.1878 12.7073L7.40847 9.7207L1.90234 12.7795Z",
    fill: "#484848",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmaway);
export default __webpack_public_path__ + "static/media/kmaway.67a3f4021d1bcbf7be3b377116e003aa.svg";
export { ForwardRef as ReactComponent };